export const AuthenticationAPI = {
    customURLNeeded: true,
    method: 'GET',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    apiVersion: 2,
    storeKey: 'AuthenticationAPI'
};
export const AuthenticationLegacyAPI = {
    customURLNeeded: true,
    method: 'GET',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    storeKey: 'AuthenticationLegacyAPI'
};

export const LanguagesJsonAPI = {
    customEndPoint: process.env.REACT_APP_BLOB_STORAGE_LOCATOIN,
    url: 'languages.json',
    method: 'GET',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    storeKey: 'LanguagesJsonAPI',
    apiVersion: 2,
    isBlobStorageAPI: true
};

export const CarePlanContentJsonAPI = {
    customEndPoint: process.env.REACT_APP_BLOB_STORAGE_LOCATOIN,
    url: 'careplancontent.json',
    method: 'GET',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    storeKey: 'CarePlanContentJsonAPI',
    isBlobStorageAPI: true
};
export const GetMemberCarePlanAPI = {
    customURLNeeded: true,
    method: 'GET',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    apiVersion: 2,
    storeKey: 'GetMemberCarePlanAPI'
};
export const GetMemberCarePlanLegacyAPI = {
    customURLNeeded: true,
    method: 'GET',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    storeKey: 'GetMemberCarePlanLegacyAPI'
};

export const GetMemberInfoAPI = {
    customURLNeeded: true,
    method: 'GET',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    apiVersion: 2,
    storeKey: 'GetMemberInfoAPI'
};

export const GetMemberInfoSilentAPI = {
    customURLNeeded: true,
    method: 'GET',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    apiVersion: 2,
    storeKey: 'GetMemberInfoSilentAPI'
};

export const GetAssessmentModulesAPI = {
    customURLNeeded: true,
    method: 'GET',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    apiVersion: 2,
    storeKey: 'GetAssessmentModulesAPI'
};

export const SaveAllSNSEAssessmentAPI = {
    url: 'xp/assessments/saveall',
    method: 'POST',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    apiVersion: 2,
    storeKey: 'SaveAllSNSEAssessmentAPI'
};
export const AssessmentQuestionsAPI = {
    customURLNeeded: true,
    method: 'POST',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    apiVersion: 2,
    storeKey: 'AssessmentQuestionsAPI'
};

export const GetCommonListAPI = {
    customEndPoint: process.env.REACT_APP_BLOB_STORAGE_LOCATOIN,
    url: 'common.json',
    method: 'GET',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    storeKey: 'GetCommonListAPI',
    apiVersion: 2,
    apiType: 'configuration',
    isBlobStorageAPI: true
};

export const SaveAssessmentAPI = () => {
    return {
        customURLNeeded: true,
        method: 'POST',
        saveOffline: true,
        responseSchema: null,
        requestSchema: null,
        queryParamsSchema: null,
        callErrorPage: false,
        storeKey: 'SaveAssessmentAPI',
        apiVersion: 2
    };
};

export const GetAuthPermissionsAPI = {
    url: 'auth/permissions',
    method: 'GET',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    apiVersion: 2,
    storeKey: 'GetAuthPermissionsAPI'
};

const CommonAPIS = [
    AuthenticationAPI,
    AuthenticationLegacyAPI,
    LanguagesJsonAPI,
    CarePlanContentJsonAPI,
    GetMemberCarePlanAPI,
    GetMemberCarePlanLegacyAPI,
    GetMemberInfoAPI,
    SaveAllSNSEAssessmentAPI,
    AssessmentQuestionsAPI,
    GetCommonListAPI,
    GetMemberInfoSilentAPI,
    GetAuthPermissionsAPI
];

export default CommonAPIS;
